import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { getAggregatedValue } from './aggregation'
import {
  RowValueGetter,
  isProcessRow,
  numericCellStyle,
  numberValueFormatter,
  percentValueFormatter,
} from './common'

// --- Profit/Loss group ---

export const profitLossColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({
    id: 'programManagement.column.profitLoss',
  }),
  children: [
    {
      colId: 'profitLoss.totalBudget',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.totalBudget',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'totalBudget')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.scheduledUsedBudget',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.scheduledUsedBudget',
      }),
      width: 100,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'scheduledUsedBudget')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.actualUsedBudget',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.actualUsedBudget',
      }),
      width: 100,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'actualUsedBudget')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.remainingBudget',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.remainingBudget',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'remainingBudget')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.totalRevenue',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.totalRevenue',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'totalRevenue')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.scheduledRevenue',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.scheduledRevenue',
      }),
      width: 100,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'scheduledRevenue')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.actualRevenue',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.actualRevenue',
      }),
      width: 100,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'actualRevenue')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.forecastRevenue',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.forecastRevenue',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'profitLoss', 'forecastRevenue')
      },
      cellStyle: numericCellStyle,
      valueFormatter: numberValueFormatter,
    },
    {
      colId: 'profitLoss.expectedProfitRatio',
      headerName: intl.formatMessage({
        id: 'programManagement.column.profitLoss.expectedProfitRatio',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        const forecastRevenue = getAggregatedValue(
          params,
          'profitLoss',
          'forecastRevenue'
        )
        const actualUsedBudget = getAggregatedValue(
          params,
          'profitLoss',
          'actualUsedBudget'
        )
        const remainingBudget = getAggregatedValue(
          params,
          'profitLoss',
          'remainingBudget'
        )
        if (
          forecastRevenue == null ||
          actualUsedBudget == null ||
          remainingBudget == null
        ) {
          return null
        }
        const totalCost = actualUsedBudget + remainingBudget
        if (totalCost === 0) return null
        return forecastRevenue / totalCost
      },
      cellStyle: numericCellStyle,
      valueFormatter: percentValueFormatter,
    },
  ],
}
